export const u = (url, w = 1600) => {
  if (url.startsWith("/")) return url;
  return url.includes("pexels")
    ? `${url}?auto=compress&cs=tinysrgb&w=${w}`
    : `${url}?auto=format&fit=crop&w=${w}&q=80`;
};
